import {
  BufferGeometry,
  LineBasicMaterial,
  LineLoop,
  Material,
  MeshBasicMaterial,
  Vector3,
} from "three";
import * as Config from "../config/ViewerConfig";
import { AutoAttenuableState } from "../measurement/types";

export class ExtendedLineLoop extends LineLoop {
  private _points: Vector3[];
  private _defaultMaterial: Material;
  private _selectedMaterial: Material;
  private _hoveredMaterial: Material;

  get points() {
    return this._points;
  }
  constructor(material: Material = new MeshBasicMaterial({ color: 0x0000ff })) {
    const geometry = new BufferGeometry();
    super(geometry, material);

    this._defaultMaterial = material;
    this._selectedMaterial = new LineBasicMaterial({
      color: Config.SELECTED_MEASUREMENT_COLOR,
      linewidth: 3,
      depthTest: false,
    });
    this._hoveredMaterial = new LineBasicMaterial({
      color: Config.HOVERED_MEASUREMENT_COLOR,
      linewidth: 3,
      depthTest: false,
    });
  }

  public prepareRendering(points: Vector3[]) {
    this.geometry.setFromPoints(points);
  }

  public setMaterialByState(state: AutoAttenuableState) {
    this.material = {
      default: this._defaultMaterial,
      selected: this._selectedMaterial,
      hovered: this._hoveredMaterial,
    }[state];
  }
}
